export const cibPagekit = ["32 32","<path d='M3.203 0v32h12.797v-4.703h-8.094v-22.594h16.193v17.891h-8.094v4.703h12.797v-27.297z'/>"]